import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
import { nurseService } from "src/api/nurse/nurseService"
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";

interface AddGuideModalProps {
  id: number;
  onSuccess?: () => void;
}
interface GuideItem {
  id: number;
  name: string;
  note: string;
  isactive: string;
}

function AddGuideModal({ id, onSuccess }: AddGuideModalProps) {
  //const { id } = AddGuideModalProps;
  const { t } = useTranslate();
  //const isEditing = Number(id) > 0;
  const [name, setName] = useState("");
  const [note, setNote] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastType, setToastType] = useState<"success" | "error">("success");
  const [toastTitle, setToastTitle] = useState("");
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    if (id && id > 0) {
      const fetchGuideDetail = async () => {
        const response = await nurseService.nurseCare.getNurseCareGroupById<GuideItem>(id);
        const selected = response;
        console.log(selected);
        if (selected) {
          setName(selected.name || "");
          setNote(selected.note || "");
          setIsActive(selected.isactive === "1");
        }
      };

      fetchGuideDetail();
    }

  }, [id]);


  const handleSave = async () => {
    const data = {
      name,
      note,
      isactive: isActive ? "1" : "0",
    };
    try {
      let response: any;
      if (id && id > 0) {
        response = await nurseService.nurseCare.updateNurseCareGroup({ id: Number(id) }, data);
      } else {
        response = await nurseService.nurseCare.createNurseCareGroup(data);
      }

      const isSuccess = response?.issuccess !== false;

      if (isSuccess) {
        setToastType("success");
        setToastTitle(t("toast.title"));
        setToastMessage(t("toast.content"));
        setToastOpen(true);
        if (onSuccess) onSuccess();
      } else {
        setToastType("error");
        setToastTitle(t("toast.error-title"));
        setToastMessage(response?.message || t("toast.error-content"));
        setToastOpen(true);
      }
    } catch (error) {
      setToastType("error");
      setToastTitle(t("toast.error-title"));
      setToastMessage(t("toast.error-content"));
      setToastOpen(true);
    }
  };
  const handleDelete = async () => {
    try {
      if (id && Number(id) > 0) {
        await nurseService.nurseCare.deleteNurseCareGroup({ id: Number(id) });
        if (onSuccess) onSuccess();
      }
    } catch (error) {
      console.error("Kılavuz silme sırasında hata oluştu:", error);
    }
  };
  return (
    <Box sx={{ p: 1 }}>
      <Box sx={{ display: "flex", gap: 1, borderBottom: "1px solid #E0E0E0", pb: 1 }}>
        <ByzNurseSaveButton onClick={handleSave} />
        {id && Number(id) > 0 && <ByzNurseDeleteButton onClick={handleDelete} />}
      </Box>
      <Grid
        container
        spacing={2}
        alignItems="stretch"
        sx={{ borderBottom: "1px solid #E0E0E0", py: ".6rem" }}
      >
        <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
          <ByzMuiTypography>{t("nurse.care-plans.guide-name")}</ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMuiTextField
            label={t("nurse.care-plans.guide-name")}
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        alignItems="stretch"
        sx={{ borderBottom: "1px solid #E0E0E0", py: ".5rem" }}
      >
        <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
          <ByzMuiTypography>{t("note")}</ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMuiTextField
            label={t("note")}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ borderBottom: "1px solid #E0E0E0" }}>
        <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
          <ByzMuiTypography>{t("active")}</ByzMuiTypography>
        </Grid>
        <Grid
          item
          xs={8}
          sx={{
            display: "flex",
            alignItems: "center",
            p: 2,
            mt: 1,
          }}
        >
          <ByzMuiCheckBox checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
        </Grid>
      </Grid>
      <ByzMuiSnackBar
        open={toastOpen}
        type={toastType}
        title={toastTitle}
        message={toastMessage}
        onClose={() => setToastOpen(false)}
      />
    </Box>
  );
}

export default AddGuideModal;
